import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		lstfn8: [],
		fn8: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		isLiquidation: false,
		hasNext: false,
		lastUpdatedRegister: null,
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getfn8(state) {
			let fn8 = { ...state.fn8 }
			return fn8
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		set(state, fn8) {
			state.fn8 = fn8
			if (fn8) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.fn8 = null
		},
		setParamsDataTable(state, payload) {
			state.lstfn8 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setfn8(state, fn8) {
			state.fn8 = fn8
		},
		setLstfn8(state, lstfn8) {
			state.lstfn8 = lstfn8
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			let payload = await this._vm.$axios
				.get(`/Financial/CheckTitle/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstfn8", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async find({ commit, dispatch }, fn8doc) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/Financial/CheckTitle/Find/${fn8doc}`)
				.then(response => {
					let fn8 = Utils.ValidateAxiosResponse(response.data)
					commit("set", fn8)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},		
		async save({ getters, dispatch, state }, fn8) {
			if (getters.getUpdate) {
				return await dispatch("update", fn8)
			}
			return await dispatch("insert", fn8)
			
		},
		async insert({ commit, getters, dispatch }, fn8) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/Financial/CheckTitle/Insert", fn8)
				.then(response => {
					let validated = Utils.ValidateAxiosResponse(response.data)
					commit("setLastUpdatedRegister", validated)
					commit("setfn8", null)
					return validated
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }, fn8) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/Financial/CheckTitle/Update", fn8)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ getters, dispatch }, fn8doc) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/Financial/CheckTitle/Delete/${fn8doc}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
	},
}
